// Keepers for the season ahead (PLAN-2026-10-27-the-next-season §2.3, §5):
// `GET /leagues/:id/keepers`, and a team's keepers saved with `PUT
// /leagues/:id/teams/:teamId/keepers`. A practice league keeps nobody, so the
// simulator has nothing to say and nothing is asked of it.

import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { KeepersView, type KeepersRequest, type Snapshot } from '@fsp/domain';
import { send, type Reply } from './api';
import { useLeagueView } from './leagueSource';
import { thenRefresh } from './moves';
import { leagueIdFromPath } from './route';

const SIM_AS_OF = new Date(0).toISOString();

export function useKeepers(): Snapshot<KeepersView> {
  const { pathname } = useLocation();
  const leagueId = useMemo(() => leagueIdFromPath(pathname), [pathname]);
  return useLeagueView(
    leagueId === null ? null : `/leagues/${leagueId}/keepers`,
    KeepersView,
    null,
    SIM_AS_OF,
  );
}

/** A team's keepers, in order; the reads on screen ask again once it lands. */
export function saveKeepers(
  leagueId: string,
  teamId: string,
  playerIds: readonly string[],
): Promise<Reply<KeepersView>> {
  return thenRefresh(
    leagueId,
    send(
      'PUT',
      `/leagues/${encodeURIComponent(leagueId)}/teams/${encodeURIComponent(teamId)}/keepers`,
      { playerIds: [...playerIds] } satisfies KeepersRequest,
      KeepersView,
    ),
  );
}
